"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Функция преобразования value в defaultValue, при условии что value = null или value = undefined.
 * @param value - входное значение (type T)
 * @param defaultValue - значение (type T | string), по умолчанию  '-' (type string)
 * @returns {T | string} - возврашет value(type T) или defaultValue (type T | string)
 */
function transformVariable(value, defaultValue) {
    if (defaultValue === void 0) { defaultValue = '-'; }
    if (value === null || value === undefined) {
        return defaultValue;
    }
    return value;
}
exports.transformVariable = transformVariable;
//# sourceMappingURL=transformVariable.js.map